import { isDevelopment, isLocal, isStaging } from 'UTILS/env';

export const partnerIntegrationsEnabled =
  isStaging() || isDevelopment() || isLocal();
